import {
  GroupAdapterInteface,
  ListGroupsInput,
} from 'src/adapter/GroupAdapterInterface';
import {
  GroupModelCreateAttributes,
  GroupModelUpdateAttributes,
  GroupModelAttributes,
  GroupsAttributesAndResourcesAttributes,
} from 'src/models/GroupModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosGroupAdapter implements GroupAdapterInteface {
  async getTopGroups(
    group_type_id: string
  ): Promise<{ total: number; data: GroupModelAttributes[] }> {
    try {
      const res = await api.get('/groups', {
        params: {
          group_type_id: group_type_id,
        },
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async listGroups(
    conditions?: ListGroupsInput
  ): Promise<{ total: number; data: GroupModelAttributes[] }> {
    try {
      const res = await api.get('/groups', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getGroup(id: string): Promise<GroupModelAttributes> {
    try {
      const res = await api.get(`/groups/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createGroup(
    attributes: GroupModelCreateAttributes
  ): Promise<GroupModelAttributes> {
    try {
      const res = await api.post('/groups', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateGroup(
    id: string,
    attributes: GroupModelUpdateAttributes
  ): Promise<GroupModelAttributes> {
    try {
      const res = await api.put(`/groups/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteGroup(id: string): Promise<boolean> {
    try {
      return await api.delete(`/groups/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }

  async getChildsByGroupId(
    id: string
  ): Promise<GroupsAttributesAndResourcesAttributes> {
    try {
      const res = await api.get(`/groups/${id}/childs-and-resources`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
